import { __decorate } from "tslib";
import { TemplateInspectionUpdate } from "@/types/Api/Template/Update/TemplateInspectionUpdate";
import gql from "graphql-tag";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import DeleteButton from "../../DeleteButton.vue";
import MoveButton from "../../MoveButton.vue";
import ChoiceTypeAutoComplete from "./ChoiceTypeAutoComplete.vue";
import TemplateChoiceValueAutoComplete from "./TemplateChoiceValueAutoComplete.vue";
let ChoiceInspectionEdit = class ChoiceInspectionEdit extends Vue {
    editEnabled = false;
    isLoadingChoiceTypes = 0;
    titleClicked = false;
    value;
    hover;
    setEditMode(value) {
        if (!value && this.editEnabled) {
            this.doSave();
            this.titleClicked = false;
        }
        this.editEnabled = value;
    }
    onClearChoiceType() {
        if (this.value.choiceInspection) {
            this.value.choiceInspection.TemplateChoiceType = undefined;
            this.value.choiceInspection.templateChoiceTypeId = 0;
            this.doSave();
        }
    }
    onUpdateChoiceType(choiceType) {
        if (this.value.choiceInspection) {
            if (choiceType) {
                this.value.choiceInspection.TemplateChoiceType = choiceType;
                this.value.choiceInspection.templateChoiceTypeId = choiceType.id;
            }
            else {
                this.value.choiceInspection.TemplateChoiceType = undefined;
                this.value.choiceInspection.templateChoiceTypeId = 0;
            }
        }
    }
    doSave() {
        this.$promiseQueue.enqueue(() => {
            let updateObject = new TemplateInspectionUpdate(this.value);
            return new Promise((resolve, reject) => {
                this.$apollo.mutate({
                    mutation: gql `mutation ($input: UpdateTemplateInspectionInput!) 
          {
            updatedInspection: updateTemplateInspection(input: $input) {
              templateInspection {
                id
                sortOrder
              }
            }
          }`,
                    variables: {
                        input: { templateInspection: updateObject }
                    },
                    fetchPolicy: "no-cache"
                }).then(result => {
                    resolve(this.value);
                }).catch(error => {
                    reject(error);
                });
            });
        }, {
            dataObject: this.value,
            description: this.$t('update-inspection-edit-description', [this.getDescription()]).toString(),
        }, true);
    }
    getDescription() {
        if (this.value.choiceInspection?.description)
            return this.value.choiceInspection.description;
        else
            return this.$t('inspectionTitle');
    }
    onKeyDown(event) {
        if (["Enter", "Esc", "Escape"].indexOf(event.key) > -1) {
            this.closeEditMode();
        }
    }
    closeEditMode() {
        this.setEditMode(false);
    }
    showEditMode() {
        this.setEditMode(true);
    }
    onDelete() {
        return true;
    }
    get supportTouch() {
        return ('ontouchstart' in window);
    }
};
__decorate([
    Prop({ type: Object, required: true, default: null })
], ChoiceInspectionEdit.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false })
], ChoiceInspectionEdit.prototype, "hover", void 0);
__decorate([
    Emit('delete')
], ChoiceInspectionEdit.prototype, "onDelete", null);
ChoiceInspectionEdit = __decorate([
    Component({
        components: {
            MoveButton,
            DeleteButton,
            ChoiceTypeAutoComplete,
            TemplateChoiceValueAutoComplete
        },
    })
], ChoiceInspectionEdit);
export default ChoiceInspectionEdit;
